import styles from './FilterButtons.module.scss'
import { FilterType, useFilter } from '@/utils/hooks/useFilter'
import React from 'react'
import classNames from 'classnames'

type Props = {
  property: string,
  items: any[],
  selected?: any[],
  valueText?: (value: string) => string | JSX.Element,
  onClick: (property: string, value: any, filterType: FilterType) => void
}

type FilterButtonProps = {
  value: string | number,
  text: string | JSX.Element,
  active: boolean,
  onClick: (value: any) => void,
}

const FilterButton = (props: FilterButtonProps) => {
  return (
    <div
      className={classNames(styles.button, { [styles.active]: props.active })}
      onClick={() => props.onClick(props.value)}
    >
      <div className={styles.radio}>
        <div className={styles.radioInner} />
      </div>
      {props.text}
    </div>
  )
}

const FilterButtons = (props: Props) => {
  const { getValuesByPropery } = useFilter(props.items, null)

  const values = getValuesByPropery(props.property)

  const getValueText = (value: string) => {
    if (props.valueText)
      return props.valueText(value)
    return value
  }

  const onFilterButtonClick = (value: any) => {
    props.onClick(props.property, value, FilterType.Checkbox)
  }

  return (
    <div className={styles.component}>
      {
        values.map((value) =>
          <FilterButton
            key={value}
            text={getValueText(value)}
            value={value}
            active={props.selected?.includes(value) ?? false}
            onClick={onFilterButtonClick}
          />
        )
      }
    </div>
  )
}

export default FilterButtons